import {
  ICaptivateBannerWidgetCustomisation,
  WIDGET_POSITION_DESKTOP,
  WIDGET_POSITION_MOBILE,
} from '@bikdotai/bik-models/dm';
import { IShopifyFormsWidgetCustomisation } from '@bikdotai/bik-models/dm/widgets/ShopifyForms/shopifyForms.interface';

export const fetchPositionCss = (
  widgetCustomisation:
    | ICaptivateBannerWidgetCustomisation
    | IShopifyFormsWidgetCustomisation,
  isMobile: boolean,
  desktopViewCenter?: boolean,
) => {
  if (isMobile) {
    if (
      widgetCustomisation.widgetPositionMobile === WIDGET_POSITION_MOBILE.CENTER
    ) {
      return {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      };
    } else {
      return {
        bottom: 0,
        left: '50%',
        transform: 'translate(-50%, 0)',
      };
    }
  }
  if (
    desktopViewCenter ||
    widgetCustomisation.widgetPositionDesktop === WIDGET_POSITION_DESKTOP.CENTER
  ) {
    return {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    };
  } else if (
    widgetCustomisation.widgetPositionDesktop ===
    WIDGET_POSITION_DESKTOP.BOTTOM_LEFT
  ) {
    return {
      bottom: 10,
      left: 10,
      transform: 'none',
    };
  } else {
    return {
      bottom: 10,
      right: 10,
      transform: 'none',
    };
  }
};

export const fetchCloseButtonPositioner = (
  widgetCustomisation:
    | ICaptivateBannerWidgetCustomisation
    | IShopifyFormsWidgetCustomisation,
  isMobile: boolean,
  isPreview: boolean,
) => {
  if (isMobile) {
    return {
      top: isPreview ? -26 : -36,
    };
  }
  if (
    widgetCustomisation.widgetPositionDesktop ===
      WIDGET_POSITION_DESKTOP.CENTER ||
    widgetCustomisation.widgetPositionDesktop ===
      WIDGET_POSITION_DESKTOP.BOTTOM_LEFT
  ) {
    return {
      top: isPreview ? -7 : -14,
      right: isPreview ? -7 : -14,
    };
  } else {
    return {
      top: isPreview ? -7 : -14,
      left: isPreview ? -7 : -14,
    };
  }
};

export const fetchContainerWidth = (
  widgetCustomisation:
    | ICaptivateBannerWidgetCustomisation
    | IShopifyFormsWidgetCustomisation,
  isMobile: boolean,
) => {
  if (isMobile) {
    if (
      widgetCustomisation.widgetPositionMobile === WIDGET_POSITION_MOBILE.CENTER
    ) {
      return 'calc(80% + 12px)';
    }
    return '100%';
  }
  return 'calc(336px + 24px);';
};
